import React from 'react';
import { Autocomplete, Typography, Icon } from '@ann/web-components';
import { AutocompleteContainer, DescriptionContainer } from './ShareKnowledgeModal.styled';

const ShareKnowledgeModalContent = ({
  knowledgeBaseName,
  selectedUsers,
  onUsersChange,
  usersList
}) => {
  return (
    <>
      <DescriptionContainer>
        <Icon name="data_table" />
        
        <Typography
          category="body"
          size="medium"
          weight="regular"
          color="body"
        >
          {knowledgeBaseName}
        </Typography>
      </DescriptionContainer>
      <AutocompleteContainer>
        <Autocomplete
          multiple={true}
          maxTagsMode="dynamic"
          onSelectionChange={onUsersChange}
          onSearch={() => {}}
          onSuggestionSelect={() => {}}
          placeholder="Search users by name, email, or role..."
          selectedValues={selectedUsers}
          showInitialName
          suggestions={usersList}
          valueKey="user_uuid"
          labelKey="full_name"
        />
      </AutocompleteContainer>
    </>
  );
};

export default ShareKnowledgeModalContent;

